import { isPortugalMarket } from '../config/marketRegion';

export function postalCodeLabel(): string {
  return isPortugalMarket() ? 'Código postal' : 'CEP';
}

export function postalCodeColonLabel(): string {
  return `${postalCodeLabel()}:`;
}

/** Ex.: «Código postal 2410-140» ou «CEP 01310-100». */
export function postalCodeWithValue(zip: string | null | undefined): string {
  const z = String(zip || '').trim();
  if (!z) return '';
  return `${postalCodeLabel()} ${z}`;
}

/** Ex.: « • Código postal: 2410-140» (blocos de endereço). */
export function postalCodeInlineSuffix(zip: string | null | undefined): string {
  const z = String(zip || '').trim();
  if (!z) return '';
  return ` • ${postalCodeColonLabel()} ${z}`;
}
